const FADE_STATE = {
    VISIBLE: 0,
    HIDING: 1,
    HIDDEN: 2
}

export default FADE_STATE;
